var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0271 5.11797L10.918 3.03934C11.1779 2.43293 11.3078 2.12972 11.5178 1.99199C11.7014 1.87154 11.9252 1.82845 12.1404 1.87208C12.3865 1.92198 12.6198 2.15524 13.0863 2.62176L17.3723 6.90771C17.8388 7.37423 18.072 7.60749 18.1219 7.85361C18.1656 8.06884 18.1225 8.29259 18.002 8.47622C17.8643 8.6862 17.5611 8.81615 16.9547 9.07604L14.876 9.96689M12.4984 12.5L12.1823 15.2854C12.0236 16.079 11.9443 16.4758 11.7351 16.6614C11.5528 16.8231 11.3089 16.897 11.0675 16.8635C10.7905 16.8251 10.5044 16.539 9.93209 15.9667L4.02731 10.0619C3.45505 9.48966 3.16891 9.20353 3.13051 8.92648C3.09705 8.68513 3.1709 8.44122 3.33262 8.25896C3.51825 8.04975 3.91504 7.97039 4.70863 7.81167L6.97967 7.38168M6.97967 13.0143L2.26562 17.7283",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.91421,
    y1: 3.33398,
    x2: 16.6667,
    y2: 16.0864,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.75b1bf223acf0d709365b159c94c2c80.svg";
export { ForwardRef as ReactComponent };